import { HealthcareFacility } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';

import { HealthcareFacilityUpdateForm } from './HealthcareFacilityUpdateForm';
import { HealthcareFacilityUpdateFormLoader } from './HealthcareFacilityUpdateForm.loader';
import { HealthcareFacilityUpdateModalConfirmButton } from './HealthcareFacilityUpdateModalConfirmButton';

type HealthcareFacilityUpdateModalProps = {
   readonly onCancel: VoidFunction;
   readonly healthcareFacilityId: HealthcareFacility['id'];
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityUpdateModal = (props: HealthcareFacilityUpdateModalProps): JSX.Element => {
   return (
      <Modal
         title={healthcareOrganizationTranslationKeys.editHealthcareFacilityData}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'HealthcareFacilityUpdate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <HealthcareFacilityUpdateFormLoader healthcareFacilityId={props.healthcareFacilityId}>
            {({ healthcareFacility }) => (
               <HealthcareFacilityUpdateForm
                  healthcareFacility={healthcareFacility}
                  healthcareParentData={props.healthcareParentData}
               >
                  {({ handleSubmit, formState }) => (
                     <>
                        <HealthcareFacilityUpdateModalConfirmButton
                           handleSubmit={handleSubmit}
                           onDataChanged={props.onDataChanged}
                        />
                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.onCancel}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </HealthcareFacilityUpdateForm>
            )}
         </HealthcareFacilityUpdateFormLoader>
      </Modal>
   );
};
